import api from "./api";

const login = async (emailorPhone: string, password: string) => {
  return await api.post("login", {
    emailorPhone: emailorPhone,
    password: password,
  });
};

const logout = async () => {
  return await api.post("logout");
};

const getUser = async () => {
  return await api.get("user");
};

const changePassword = async (data: any) => {
  return await api.post("user/changePassword", data);
};

const auth = {
  login,
  logout,
  getUser,
  changePassword
}

export default auth;
